import React from 'react';

interface RowProps {
  className?: string;
  children?: React.ReactNode;
  'data-testid'?: string;
}

function Row({ className = '', children, ...rest }: RowProps) {
  return (
    <div className={`flex flex-wrap ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default Row;
